import { h } from 'preact'

import '../style/components/Busy.less'

const Busy = ({ busy }) => {
	return (
		<section class="Busy">
			<div class="spinner"></div>
			<p>{ busy }</p>
		</section>
	)
}

export default Busy
